
import * as __star__ from 'moment';

const {
default: __default__,
momentProperties,
suppressDeprecationWarnings,
deprecationHandler,
parseTwoDigitYear,
createFromInputFallback,
ISO_8601,
RFC_2822,
updateOffset,
defaultFormat,
defaultFormatUtc,
lang,
langData,
version,
fn,
min,
max,
now,
utc,
unix,
months,
isDate,
locale,
invalid,
duration,
isMoment,
weekdays,
parseZone,
localeData,
isDuration,
monthsShort,
weekdaysMin,
defineLocale,
updateLocale,
locales,
weekdaysShort,
normalizeUnits,
relativeTimeRounding,
relativeTimeThreshold,
calendarFormat,
HTML5_FMT
} = __star__;

export {
momentProperties,
suppressDeprecationWarnings,
deprecationHandler,
parseTwoDigitYear,
createFromInputFallback,
ISO_8601,
RFC_2822,
updateOffset,
defaultFormat,
defaultFormatUtc,
lang,
langData,
version,
fn,
min,
max,
now,
utc,
unix,
months,
isDate,
locale,
invalid,
duration,
isMoment,
weekdays,
parseZone,
localeData,
isDuration,
monthsShort,
weekdaysMin,
defineLocale,
updateLocale,
locales,
weekdaysShort,
normalizeUnits,
relativeTimeRounding,
relativeTimeThreshold,
calendarFormat,
HTML5_FMT
};
export default __default__;
